import { Component, forwardRef, Renderer2, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ListDocumentProfileSurveyService } from '../../../service/list-document-profile-survey/list-document-profile-survey.service';
import { sortObjbyName } from '../../../../../theme/functions/sortObjbyName.function';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectListDocumentProfileSurveyComponent),
  multi: true,
};

@Component({
  selector: 'app-select-list-document-profile-survey',
  templateUrl: './select-list-document-profile-survey.component.html',
  styleUrls: ['./select-list-document-profile-survey.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class SelectListDocumentProfileSurveyComponent implements ControlValueAccessor {
    @Input() listDocumentProfileSurveyId: number;
    @ViewChild('input') textarea;
    @Input() disabled: boolean;
    @Output() onMyChange = new EventEmitter();

    public listDocumentProfileSurveyOptions: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public listDocumentProfileSurveyService: ListDocumentProfileSurveyService
    ) {
        this.page = 1;
        this.per_page = 1000;
        this.query = undefined;
        this.filters = [];
        this.filters.push({key: 'activated-lk', value: '1'});
        this.getListDocumentProfileSurvey(this.query, this.filters);
    }

    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean ) {
        const div = this.textarea.nativeElement;
        const action = isDisabled ? 'addClass' : 'removeClass';
        this.renderer[action](div, 'disabled');
    }

    public change($event) {
        this.onMyChange.emit($event.target.value);
        this.onChange($event.target.value);
        this.onTouched($event.target.value);
    }

    getListDocumentProfileSurvey(query?: string, filters?: any[]) {
        this.listDocumentProfileSurveyService.getListDocumentProfileSurvey(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                const ListDocumentProfileSurveis = sortObjbyName(response.json().data,'asc');
                
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }

                this.listDocumentProfileSurveyOptions = [];
                this.listDocumentProfileSurveyOptions.push({id: undefined, name: 'choose', company: undefined});
                ListDocumentProfileSurveis.forEach(element => {
                    if (this.listDocumentProfileSurveyId === element.id) {
                        this.listDocumentProfileSurveyOptions.push({id: element.id, name: element.name + " - " + element.type, selected: true, company: element.company});
                    } else {
                        this.listDocumentProfileSurveyOptions.push({id: element.id, name: element.name + " - " + element.type, selected: false, company: element.company});
                    }
                });
            },
            error => {
                this.listDocumentProfileSurveyOptions = [];
                this.listDocumentProfileSurveyOptions.push({id: '', name: 'Error'});
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/list-document-profile-surveis/select-list-document-profile-survey/select-list-document-profile-survey.component.ts